import React from 'react'

export const Context = React.createContext()
export const CatalogContext = React.createContext()
export const BasketContext = React.createContext()